import Audit from './components/Audit';
import DocumentTypes from './components/DocumentTypes';
import { ListLayout } from '../../../components/layout/layout/ListLayout';
import { Tabs } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { CreateDocumentationModal } from 'components/modal/documentations/CreateDocumentationModal';

export const DocumentationList = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const searchParams = useMemo(() => new URLSearchParams(location.search), []);
  const tabParam = searchParams.get('tab');
  const [activeTab, setActiveTab] = useState(tabParam || 'audit');

  useEffect(() => {
    const tabFromURL = searchParams.get('tab') || 'audit';
    setActiveTab(tabFromURL);
  }, [searchParams]);

  const handleTabChange = (activeKey: string) => {
    setActiveTab(activeKey);
    searchParams.set('tab', activeKey);
    const newURL = `${location.pathname}?${searchParams.toString()}`;
    window.history.pushState({ path: newURL }, '', newURL);
  };

  return (
    <ListLayout
      title="Documentações"
      createButtonProps={{
        onClick: () => setIsModalOpen(true)
      }}
    >
      <Tabs
        defaultActiveKey={activeTab}
        onChange={handleTabChange}
        className="custom-tabs"
      >
        <Tabs.TabPane tab="Auditorias" key="audit">
          <Audit />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Tipo de documentos" key="documentTypes">
          <DocumentTypes />
        </Tabs.TabPane>
      </Tabs>
      <CreateDocumentationModal open={isModalOpen} onClose={setIsModalOpen} />
    </ListLayout>
  );
};
